import _ from 'lodash';
import ah from '../utils/ajax-helper'; // 取得櫃場關聯使用者

export var getTerminalAccounts = function getTerminalAccounts(contextRoot, noProgress, terminalId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/terminal/").concat(terminalId, "/accounts"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 設定櫃場關聯使用者

export var setTerminalRelatedCameraAPI = function setTerminalRelatedCameraAPI(contextRoot, noProgress, terminalId, relatedAccounts) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/terminal/").concat(terminalId, "/accounts"), JSON.stringify(relatedAccounts), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得貨運業者關聯使用者

export var getLogisticAccounts = function getLogisticAccounts(contextRoot, noProgress, logisticId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/logistic/").concat(logisticId, "/accounts"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 設定貨運業者關聯使用者

export var setLogisticRelatedCameraAPI = function setLogisticRelatedCameraAPI(contextRoot, noProgress, logisticId, relatedAccounts) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/logistic/").concat(logisticId, "/accounts"), JSON.stringify(relatedAccounts), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};